import React from 'react';
import T from './EditableText';

/**
 * Kundenstimmen als Zitatkarten.
 *
 * Lag ursprünglich als Inline-Markup in `pages/Home.tsx`. Herausgelöst, als die
 * Kampagnen-Landingpage dieselben Stimmen zeigen sollte — dasselbe Muster wie
 * bei [TickList]: Was nur in einer Seite steht, wird beim zweiten Bedarf
 * nachgebaut statt benutzt.
 *
 * Beide Auftritte greifen bewusst auf **dieselben Textschlüssel** zu. Es sind
 * dieselben echten Rückmeldungen; ändert der Kunde einen Namen oder ein Zitat,
 * soll das an beiden Stellen gelten. Eigene Kopien wären zwei Wahrheiten über
 * denselben Menschen.
 */
const Testimonials: React.FC<{
  /** Nummern der Stimmen; erzeugt `home.stimmen.<n>.zitat` und `.name`. */
  numbers?: number[];
}> = ({ numbers = [1, 2, 3] }) => (
  <div className="autogrid">
    {numbers.map((number) => (
      <blockquote className="card testimonial" key={number}>
        <span className="testimonial__mark" aria-hidden="true">
          “
        </span>
        <p>
          <T k={`home.stimmen.${number}.zitat`} />
        </p>
        <footer>
          <T k={`home.stimmen.${number}.name`} />
        </footer>
      </blockquote>
    ))}
  </div>
);

export default Testimonials;
